module.exports = __webpack_public_path__ + "static/media/Food10.d36ef7da.jpg";